export const STAFF_AUTH_REQUIRED_MESSAGE = 'You must be signed in to complete this action.';
export const LEGACY_UNASSIGNED_LABEL = 'Unassigned staff';

function normalizeText(value) {
  const normalized = String(value || '').trim();
  return normalized || null;
}

function normalizeProfileRecord(value) {
  if (Array.isArray(value)) {
    return value[0] && typeof value[0] === 'object' ? value[0] : null;
  }

  return value && typeof value === 'object' ? value : null;
}

export function buildStaffAttributionFields({
  currentUserId,
  selectedOwnerId = null,
} = {}) {
  const createdBy = normalizeText(currentUserId);
  if (!createdBy) return null;

  return {
    created_by: createdBy,
    owner_id: normalizeText(selectedOwnerId) || createdBy,
  };
}

export function buildAttributionPerson({
  profile = null,
  fullName = null,
  avatarUrl = null,
} = {}) {
  const normalizedProfile = normalizeProfileRecord(profile);

  return {
    fullName: normalizeText(normalizedProfile?.full_name ?? fullName),
    avatarUrl: normalizeText(normalizedProfile?.avatar_url ?? avatarUrl),
  };
}

export function getAttributionDisplayName(person) {
  return normalizeText(person?.fullName) || LEGACY_UNASSIGNED_LABEL;
}

export function hasAttributionIdentity(person) {
  return Boolean(normalizeText(person?.fullName) || normalizeText(person?.avatarUrl));
}
